const DID = 'did'
const DIDNOT = 'didnot'
const SKIPPED = 'skipped'
const COMMIT = 'commit'
const TODAY = 'today'

export const getActivitiesColors = (userActivities, currentDay) => {
  const states = []

  userActivities.map((activity, index) => {
    const isCurrentDot = currentDay === index + 1
    const isNotDone = [COMMIT, SKIPPED, DIDNOT].includes(activity.actionType) && !isCurrentDot
    const isDid = activity.actionType === DID

    if (isCurrentDot && !isDid && isActionTypeNotExists(TODAY, states)) {
      states.push({ status: TODAY, message: "Today's activity" })
    }
    if (isDid && isActionTypeNotExists(DID, states)) {
      states.push({ status: DID, message: 'I Did It' })
    }
    if (isNotDone && isActionTypeNotExists(DIDNOT, states)) {
      states.push({ status: DIDNOT, message: "I Didn't do It" })
    }
  })

  return states
}

const isActionTypeNotExists = (actionType, actionsInfo) => {
  return !actionsInfo.length || actionsInfo.filter(actionInfo => actionInfo.status === actionType).length <= 0
}
